import { useMemo, useState } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import AllPolicySection from "../../../policies/components/AllPolicySection/AllPolicySection";
import {
  operatorTravellersFilterOptions,
  operatorTripsFilterOptions,
} from "../../constants/operatorListConstants";

const OperatorIssuedPolicies = () => {
  const { operator } = useOutletContext();
  const { uuid } = useParams();
  const [viewMode, setViewMode] = useState("trips");

  const operatorId = operator?.operator?.id;
  const endpoints = useMemo(
    () => ({
      trips: `issuance/policies/user-specific/trips/?operator_id=${operatorId}`,
      travellers: `issuance/policies/user-specific/travellers/?operator_id=${operatorId}`,
    }),
    [operatorId]
  );

  const pathOverrides = useMemo(
    () => ({
      tripDetails: (row) => `/operator/operators/${uuid}/policies-issued/${row.id}`,
      travellerDetails: (row) => `/operator/operators/${uuid}/policies-issued/${row.id}`,
      endorsement: (row) => `/issuance/endorsement/${row.id}`,
    }),
    [uuid]
  );

  if (!operatorId) return null;

  return (
    <AllPolicySection
      tripsEndpoint={endpoints.trips}
      travellersEndpoint={endpoints.travellers}
      viewMode={viewMode}
      onViewChange={setViewMode}
      showStats={false}
      pathOverrides={pathOverrides}
      tripsFilterOptions={operatorTripsFilterOptions}
      travellersFilterOptions={operatorTravellersFilterOptions}
    />
  );
};

export default OperatorIssuedPolicies;
